import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

interface foodMenuItemApproval {
    foodMenuItemApprovalName: any;
    id: any | null | undefined;
    customDescription: any;
    baseRate: any;


}


interface foodMenuItemApprovalState {
    data: foodMenuItemApproval[];
    loading: boolean;
    error: string | null;
}


const PORT = import.meta.env.VITE_COOK_PORT;
const URL = import.meta.env.VITE_API_COOK_URL;

// Diet Mapping Code
export const fetchfoodMenuItemApproval = createAsyncThunk<foodMenuItemApproval[], void, { rejectValue: string }>(
    'foodMenuItemApproval/fetchfoodMenuItemApproval',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.get<{ data: foodMenuItemApproval[] }>('/get_all_food_menu_item_approval', PORT, URL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const createfoodMenuItemApproval = createAsyncThunk<foodMenuItemApproval, any, { rejectValue: string }>(
    'foodMenuItemApproval/createfoodMenuItemApproval',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.post<{ data: foodMenuItemApproval }>('create_food_menu_item_approval', params, PORT, URL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const updatefoodMenuItemApproval = createAsyncThunk<foodMenuItemApproval, any, { rejectValue: string }>(
    'foodMenuItemApproval/updatefoodMenuItemApproval',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.put<{ data: foodMenuItemApproval }>('update_food_menu_item_approval', params, PORT, URL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);
export const foodMenuItemApprovalSlice = createSlice({
    name: 'foodMenuItemApproval',
    initialState: {
        data: [],
        loading: false,
        error: null,
    } as foodMenuItemApprovalState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Diet Mapping Code
            .addCase(fetchfoodMenuItemApproval.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchfoodMenuItemApproval.fulfilled, (state, action: PayloadAction<foodMenuItemApproval[]>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchfoodMenuItemApproval.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(createfoodMenuItemApproval.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createfoodMenuItemApproval.fulfilled, (state, action: PayloadAction<foodMenuItemApproval>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(createfoodMenuItemApproval.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(updatefoodMenuItemApproval.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updatefoodMenuItemApproval.fulfilled, (state, action: PayloadAction<foodMenuItemApproval>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(updatefoodMenuItemApproval.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
    },
});

export default foodMenuItemApprovalSlice.reducer;